//@author: devin

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core";
import { Proto } from "../../pojo/Proto";
import { FavoriteItem, FavoriteService } from "../../services/favorite.service";
import { UserprefService } from "../../services/userpref.service";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { FavoriteApi } from "./favorite.api";
import { jSith } from "../../util/jquery-replacement";

// TODO: this should be a directive, or it should get a proper template
@TypeManagerDecorator("s25-favorite")
@Component({
    selector: "s25-favorite",
    template: ` <ng-content></ng-content> `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25FavoriteComponent implements OnInit, OnChanges {
    @Input() item?: FavoriteItem & { onAction?: () => void } = undefined;

    // GROSS!!!
    public get looseItem(): FavoriteItem & { isFav?: boolean; favorite?: Proto.CharBoolean } {
        return this.item;
    }

    isLoggedIn: boolean = false;

    constructor(
        private elementRef: ElementRef,
        private changeDetector: ChangeDetectorRef,
    ) {
        FavoriteApi.Instances.push(this);
    }

    refresh(isFav: boolean) {
        this.looseItem.isFav = isFav;
        this.changeDetector.markForCheck();
        this.starClass();
    }

    getElement() {
        return this.elementRef.nativeElement.children.length && this.elementRef.nativeElement.children[0];
    }

    starClass() {
        let element = this.getElement();
        if (element) {
            jSith.removeClass(element, "ngStarOn");
            jSith.removeClass(element, "ngStarOff");
            if (this.looseItem.isFav || this.looseItem.favorite === "T") {
                jSith.addClass(element, "ngStarOn");
            } else {
                jSith.addClass(element, "ngStarOff");
            }
        }
    }

    toggleFav() {
        void FavoriteService.toggle(this.item);
        // modifying input objects is REALLY BAD
        this.looseItem.isFav = !this.looseItem.isFav;
        this.looseItem.favorite = this.looseItem.isFav ? "T" : "F";
        this.changeDetector.markForCheck();
    }

    onAction() {
        this.toggleFav(); //toggle fav and persist
        //update stars for this and anywhere else this is starred
        FavoriteApi.refreshInstances({
            isFav: this.looseItem.isFav,
            itemId: this.looseItem.itemId,
            itemTypeId: this.item.itemTypeId,
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.item && !changes.item.firstChange) {
            this.looseItem.isFav = this.isFav();
            this.starClass();
        }
    }

    isFav() {
        return !!this.looseItem.isFav || this.looseItem.favorite === "T";
    }

    ngOnInit() {
        let element = this.getElement();
        if (element) {
            element.angBridge = this;

            this.isLoggedIn = false;
            jSith.addClass(element, "ngMinImgDim ngCpointer");

            if (this.item?.itemId) {
                this.item.onAction = () => this.onAction();

                UserprefService.getLoggedIn().then((isLoggedIn) => {
                    this.isLoggedIn = isLoggedIn;
                    if (this.isLoggedIn) {
                        this.looseItem.isFav = this.isFav(); //set isFav to boolean
                        this.changeDetector.markForCheck();

                        jSith.on(element, "click", null, (e: Event) => {
                            //bind click to toggling of favorite
                            e && e.stopPropagation && e.stopPropagation(); //prevent another click from being processed
                            this.onAction();
                        });

                        this.starClass(); //init class on element
                    }
                });
            }
        }
    }
}
